import VacancyExpiredUpdateModal from './VacancyExpiredUpdateModal.component';

export default VacancyExpiredUpdateModal;
